import React from "react";
import _ from "lodash";
import { Col, Container, Row } from "reactstrap";

const NextNumberModal = ({ current_number, paramsReducerr, currentAlphabet }) => {
  const parameters = _.get(paramsReducerr, "3_playing");
  let customClass = "circle-red";

  function coustomClass(curr_number) {
    if (curr_number < 16) {
      customClass = "circle-red";
    } else if (curr_number >= 16 && curr_number <= 30) {
      customClass = "circle-blue";
    } else if (curr_number >= 31 && curr_number <= 45) {
      customClass = "circle-purple";
    } else if (curr_number >= 46 && curr_number <= 60) {
      customClass = "circle-orange";
    } else if (curr_number > 60) {
      customClass = "circle-green";
    } else {
      customClass = "circle-none";
    }
    return customClass;
  }

  return (
    <>
      {/* <div className="next-number-modal-bg">
      <div className="next-number-modal">
        <div className="next-number-modal-dialog">
          <div className="next-number-modal-content">
            <h2 className="next-num">the next number is</h2>
            <div className="circle">
              <p className="alpha">B</p>
              <p className="num">15</p>
            </div>
          </div>
        </div>
      </div>
      </div> */}
      <Container>
        <Row>
          <Col xl={8} lg={8}>
            <div className="next-number-modal">
              <div className="next-number-dialog">
                <div className="next-number-content">
                  <h2 className="next-num">{parameters?.ball_label}</h2>
                  <div className={coustomClass(current_number)}>
                    <p className="alpha">{currentAlphabet(current_number)}</p>
                    <p className="num">{current_number}</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NextNumberModal;
